/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Filter } from '../../../model/Filter';
import { Command } from '../../../model/Command';
import { ListController } from '../../ListController';

class AlarmTypeListController extends ListController {
    /** @ngInject */
    constructor(alarmTypeService, waitSpinnerService, $q, $state, $stateParams, $log, notificationService,
        configuration, filterService, dialogService, $scope) {
        super(configuration, notificationService, waitSpinnerService, $state, $stateParams, $q, $log);
        this.alarmTypeService = alarmTypeService;
        this.filterService = filterService;
        this.dialogService = dialogService;
        this.$scope = $scope;
        // mdDataTable doesn't support ES6 syntax with $ctrl variable in templates. That's why we must attach the reload
        // callback to the scope with an arrow function so as it can be called by this component with the correct 'this'
        // binding.
        this.$scope.reload = () => this.reload();
        this.$log.debug('Controller \'AlarmTypeList\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.paging.sort = 'name';
        this.commands = [];
        this.initFilters();

        this.reload().then(() => this.initCommands());
    }

    /**
     * Initializes the filters available at the top of the view.
     */
    initFilters() {
        this.filters.push(
            Filter.emptyLikeFilter('name', 'model.alarmtype.name'),
            Filter.emptyLikeFilter('code', 'model.alarmtype.code')
        );
    }

    /**
     * Initializes the commands available in the view header.
     */
    initCommands() {
        this.commands.push(
            Command.stateCommand('ui.alarmtype.create', 'images/svg/add.svg', 'gmao.alarm.type.create'),
            Command.handlerCommand(undefined, 'images/svg/reset.svg', () => this.reload())
        );
    }

    /**
     * Reloads the list of alarm types.
     *
     * @return {Promise} A promise providing the list of alarm types.
     */
    reload() {
        return this.handleRestServiceCall(
            this.alarmTypeService.searchEntities({
                params: this.filterService.buildPagingParams(this.paging),
                data: this.filterService.buildFilters(this.filters)
            }),
            data => {
                this.model.data = data.content;
                this.model.totalElements = data.totalElements;
            }
        );
    }

    /**
     * Shows a confirmation dialog before deleting a type of alarm. If the dialog is confirmed, the type is deleted.
     *
     * @param {integer} id ID of the type of alarm.
     * @return {Promise} A promise containing the confirmation result.
     */
    showDeleteConfirmationDialog(id) {
        return this.dialogService.showConfirmationDialogWithMessage('ui.alarmtype.deleteconfirmation').then(
            confirmed => {
                if (confirmed) {
                    this.deleteAlarmType(id);
                }
                return confirmed;
            }
        );
    }

    /**
     * Deletes immediately a type of alarm without confirmation, and reloads the list of types.
     *
     * @param {integer} id ID of the type of alarm.
     */
    deleteAlarmType(id) {
        return this.handleRestServiceCall(this.alarmTypeService.deleteEntity(id), () => {
            this.notificationService.pushMessage('ui.alarmtype.deleted',
                this.configuration.NOTIFIER_LEVEL_INFO);
            this.reload();
        });
    }
}

export const alarmTypeListComponent = {
    template: require('./alarmtype-list.html'),
    controller: AlarmTypeListController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/alarm/component/AlarmTypeList.js